<template>
    <div class="footer_link">
        <div class="link_box">
            <div class="flex_row_between_start wrapper">
                <div class="left_box">
                    <div class="info">
                        <img class="l_img" src="@/assets/footer/logo.png" alt="">
                    </div> 
                    <div class="tel flex">
                        <span class="t_img"><img src="@/assets/footer/tel.png" alt=""></span>
                        <span>电话：18721985300</span>
                    </div>
                    <div class="email flex">
                        <span class="e_img"><img src="@/assets/footer/email.png" alt=""></span>
                        <div>
                        <p>客服邮箱：research@opmbiosciences.com</p>
                        <!-- <p style="margin-top: 10px;">销售邮箱：research@opmbiosciences.com</p>
                        <p style="margin-top: 10px;">CDMO BD邮箱：research@opmbiosciences.com</p> -->
                        </div>
                    </div>
                    <div class="fdLink">
                        <span><b>友情链接：</b></span>
                        <a>ATCC、</a>
                        <a>细胞库、</a>
                        <a>政策库</a>
                    </div>
                </div>


                <div class="link_wrap" v-for="({ categoryName, categoryId, articleList }, index) in navList.data.slice(0,2)"
                    :key="index">
                    <p @click="toarticle(categoryId)">{{ categoryName }}</p>
                    <li v-for="({ title, cateId, articleId }, index) in articleList" :key="index">
                        <router-link :to="{ path: '/article', query: { cateId: cateId, articleId: articleId } }" replace>
                            <a>{{ title }}</a>
                        </router-link>
                    </li>
                </div>

                <div class="flex">
                    <div class="code code-first">
                        <img src="@/assets/footer/aopumai_wx.png" alt="">
                        <div>扫描二维码关注</div>
                        <div>奥浦迈官方服务号</div>
                    </div>
                    <div class="code">
                        <img src="@/assets/footer/aopumai_gongzong.png" alt="">
                        <div>扫描二维码关注</div>
                        <div>奥浦迈官方公众号</div>
                    </div>
                </div>

            </div>
        </div>
        <div :class="navList.data.length > 0 ? 'bottom_box' : 'bottom_box_none'">
            <FooterBottom></FooterBottom>
        </div>
    </div>
</template>

<script>
import FooterBottom from "./FooterBottom";
import { reactive, getCurrentInstance } from 'vue'

export default {
    name: "FooterLink",
    components: {
        FooterBottom
    },
    props: ["caseNumber"],
    setup() {
        const bg = {
            backgroundImage:
                "url(" + require("../assets/footer/footer_bg.png") + ")",
            backgroundSize: "100% 100%"
        };
        const navList = reactive({ data: [] });
        const getInitData = () => {
            const { proxy } = getCurrentInstance();
            let param = {};
            param.cateSize = 8;
            param.articleSize = 5;
            proxy.$get('v3/cms/front/article/helpList', param).then(res => {
                if (res.state == 200) {
                    navList.data = res.data;
                }
            })
        }
        getInitData();
        return { bg, navList }
    },
};
</script>

<style lang="scss" scoped>
.footer_link {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    // background: #2B2B2B;
    background: url('~@/assets/footer/ao_footer_bg.png') no-repeat;
    background-size: 100% 100%;

    .wrapper {
        width: 100%;
        padding-bottom: 22px;
        // border-bottom: 1px solid #464646;
        border-bottom: 1px solid #096D9F;
        .left_box{
            width: 400px;
            color: #FFFFFF;
            .info{
                font-size: 14px;
                font-weight: 500;
                .l_img{

                }
            }
            .tel{
                margin-top: 32px;
                font-size: 16px;
                font-weight: 400;
                align-items: center;
                .t_img{
                    margin-right: 8px;
                }
            }
            .email{
                font-weight: 400;
                margin-top: 20px;
                .e_img{
                    margin-right: 8px;
                }
                p{
                    font-size: 16px;
                    color: #FFFFFF;
                }
            }
            .fdLink{
                margin-top: 43px;
                font-size: 16px;
                a{
                    color: #B7CEE0;
                }
            }
        }
    }

    .link_box {
        width: 1200px;
        // width: 1100px;
        margin: 58px 40px 33px;
        // padding: 0 20px;
        // margin: 0 auto 30px;
        display: flex;
        position: relative;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;

        .link_wrap {
            text-align: center;

            p {
                // color: rgba(255, 255, 255, .9);
                color: #fff;
                font-size: 20px;
                font-weight: bold;
                margin-bottom: 26px;
            }

            li {
                line-height: 36px;

                a {
                    // color: #ccc;
                    // color: #DDE4EA;
                    color: #B7CEE0;
                    font-size: 16px;
                    font-weight: 300;
                    line-height: 28px;

                    &:hover {
                        // color: $colorMain3
                        color: #fff;
                    }
                }
            }
        }

        .code {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
                width: 104px;
                height: 104px;
                margin-bottom: 19px;
            }

            div {
                color: #B7CEE0;
                font-size: 14px;
                margin-bottom: 7px;
            }
        }
        .code-first {
            margin-right: 50px;
        }

        .link_wrap:nth-child(1) {
            /*width: 295px;*/
            /*text-align: left;*/
        }

        .link_wrap:nth-child(2) {
            /*width: 270px;*/
        }

        .link_wrap:nth-child(3) {
            /*width: 280px;*/
        }

        .link_wrap:nth-child(4) {
            /*width: 280px;*/
        }

        .link_wrap:nth-child(5) {
            /*width: 280px;*/
        }
    }

    .bottom_box,
    .bottom_box_none {
        position: relative;
        width: 1903px;
        height: 86px;
        overflow: hidden;
    }

    .bottom_box_none {
        width: 100%;
        height: 87px;
        background-color: #333333;
    }
}</style>